import isEmail from 'validator/lib/isEmail'
import { parsePhoneNumberWithError } from 'libphonenumber-js'

export const validateEmail = (email) => {
	if (!email || email.trim() === '') return null
	return isEmail(email.trim()) ? null : 'Invalid email address'
}

export const validatePhone = (phone) => {
	if (!phone || phone.trim() === '') return null
	try {
		const parsed = parsePhoneNumberWithError(phone.trim())
		return parsed.isValid() ? null : 'Invalid phone number'
	} catch {
		return 'Invalid phone number'
	}
}

export const dedupStrings = (values) => {
	const out = []
	const seen = new Set()
	for (const raw of values || []) {
		const v = raw == null ? '' : String(raw).trim()
		if (!v || seen.has(v)) continue
		seen.add(v)
		out.push(v)
	}
	return out
}
